import { NgModuleFactoryLoader, Injector, ComponentFactory } from '@angular/core';
import { DYNAMIC_COMPONENT } from './dynamic-component.manifest';
import { from, Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./dynamic-component-loader.module";
var DynamicComponentLoaderService = /** @class */ (function () {
    function DynamicComponentLoaderService(manifest, loader, injector) {
        this.manifest = manifest;
        this.loader = loader;
        this.injector = injector;
    }
    DynamicComponentLoaderService.prototype.getComponentFactory = function (componentId, injector) {
        var _this = this;
        var manifest = this.manifest.find(function (m) { return m.componentId === componentId; });
        if (!manifest) {
            manifest = this.manifest.find(function (m) { return m.componentId === "defaultPanel"; });
        }
        var p = this.loader.load(manifest.loadChildren)
            .then(function (ngModuleFactory) {
            var moduleRef = ngModuleFactory.create(injector || _this.injector);
            // Read from the moduleRef injector and locate the dynamic component type
            var dynamicComponentType = moduleRef.injector.get(DYNAMIC_COMPONENT);
            // Resolve this component factory
            return moduleRef.componentFactoryResolver.resolveComponentFactory(dynamicComponentType);
        });
        return from(p);
    };
    DynamicComponentLoaderService.prototype.getDataMapperFor = function (componentId) {
        var manifest = this.manifest.find(function (m) { return m.componentId === componentId; });
        return manifest && manifest.dataMapper || null;
    };
    DynamicComponentLoaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DynamicComponentLoaderService_Factory() { return new DynamicComponentLoaderService(i0.ɵɵinject(i1.DYNAMIC_COMPONENT_MANIFESTS), i0.ɵɵinject(i0.NgModuleFactoryLoader), i0.ɵɵinject(i0.INJECTOR)); }, token: DynamicComponentLoaderService, providedIn: "root" });
    return DynamicComponentLoaderService;
}());
export { DynamicComponentLoaderService };
